namespace RedBullMOBILE360.AutomaticReports {
    export interface MonitorAlertRow {
        Id?: number;
        QueryString?: string;
        AlertChannel?: string;
        Audience?: string;
        Enabled?: number;
        AlertMsg?: string;
        Schedule?: string;
    }

    export namespace MonitorAlertRow {
        export const idProperty = 'Id';
        export const nameProperty = 'QueryString';
        export const localTextPrefix = 'AutomaticReports.MonitorAlert';
        export const deletePermission = 'AutomaticReports:MonitorAlert';
        export const insertPermission = 'AutomaticReports:MonitorAlert';
        export const readPermission = 'AutomaticReports:MonitorAlert';
        export const updatePermission = 'AutomaticReports:MonitorAlert';

        export declare const enum Fields {
            Id = "Id",
            QueryString = "QueryString",
            AlertChannel = "AlertChannel",
            Audience = "Audience",
            Enabled = "Enabled",
            AlertMsg = "AlertMsg",
            Schedule = "Schedule"
        }
    }
}
